import { StringUtils } from ".";

interface ILocalStore {
    set(key: string, data: any): ILocalStore;
    get<T>(key: string, defaultValue?: T): T | null;
    remove(key: string): ILocalStore;
}

export const LocalStore: ILocalStore = {
    set(key: string, data: any): ILocalStore {
        try {
            localStorage.setItem(key, StringUtils.stringify(data));
        } catch (error) {}
        return this;
    },
    get<T>(key: string, defaultValue?: T): T | null {
        try {
            const value = localStorage.getItem(key);
            if (!value) {
                return defaultValue || null;
            }
            const data = StringUtils.parse<T>(value);
            return data;
        } catch (error) {
            return null;
        }
    },
    remove(key: string): ILocalStore {
        try {
            localStorage.removeItem(key);
        } catch (error) {}
        return this;
    },
};

export default LocalStore;
